module.exports = __webpack_public_path__ + "static/media/ico-map.a67f0e1a.svg";